const S = ["SALES_EST", "SALES_SQ_FT_EST", "TRANSACTIONS_EST"];
export {
  S as SALES
};
//# sourceMappingURL=index.es451.js.map
